import cn from "classnames";
import Datetime from "components/shared/datetime";
import { paths } from "helpers/paths";
import moment from "moment";
import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { NavLink, Redirect, Route, Switch, useLocation } from "react-router-dom";
import BillingCharges from "./charges";
import BillingDocumentDownload from "./documentDownload";
import BillingDocuments from "./documents";
import BillingNotificationUsers from "./notificationUsers";
import BillingPayments from "./payments";

const propsConfig = (key) => ({
    inPortal: true,
    inputProps: {
        name: key,
        type: "date",
    },
    libOptions: {
        isClearable: false,
        className: "form-control form-control-xs",
    },
    wrapper: "b-filter__body-cell",
});

export default function DataTable(props) {
    const [filters, setFilters] = useState({ from: moment().subtract(6, "months"), to: moment().add(4, "months") });
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const showDateFilters = location.pathname !== paths.profileBillingNotifications;
    const refreshData = () => {
        setLoading(true);
        const reqParams = {};
        if (filters.from) {
            reqParams.from = filters.from;
        }
        if (filters.to) {
            reqParams.to = filters.to;
        }
        props.getData(reqParams).then(() => setLoading(false));
    };

    return (
        <div className={cn("card card-body", { loading })}>
            {showDateFilters && (
                <div className="d-flex align-items-start mb-3">
                    <div className="d-inline-block">
                        <Datetime
                            {...propsConfig("from")}
                            onChange={({ name, value }) => setFilters({ ...filters, [name]: value })}
                            value={filters.from}
                        />
                    </div>
                    <div className="d-inline-block px-3">&mdash;</div>
                    <div className="d-inline-block">
                        <Datetime
                            {...propsConfig("to")}
                            onChange={({ name, value }) => setFilters({ ...filters, [name]: value })}
                            value={filters.to}
                        />
                    </div>
                    <div className="d-inline-block ml-2">
                        <button type="button" className="btn btn-xs btn-brand" onClick={refreshData}>
                            Обновить
                        </button>
                    </div>
                </div>
            )}
            <Scrollbars style={{ height: 48 }}>
                <ul className="profile__menu profile-menu no-bullet d-flex">
                    <li>
                        <NavLink
                            to={paths.profileBillingDocuments}
                            className="profile-menu__link"
                            activeClassName="profile-menu__link--active"
                        >
                            Документы
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={paths.profileBillingPayments}
                            className="profile-menu__link"
                            activeClassName="profile-menu__link--active"
                        >
                            Платежи
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={paths.profileBillingCharges}
                            className="profile-menu__link"
                            activeClassName="profile-menu__link--active"
                        >
                            Списания
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={paths.profileBillingNotifications}
                            className="profile-menu__link"
                            activeClassName="profile-menu__link--active"
                        >
                            Настройки уведомлений
                        </NavLink>
                    </li>
                </ul>
            </Scrollbars>
            <div className={cn("mt-3", { "table-responsive": showDateFilters })}>
                <Switch>
                    <Route
                        exact
                        path={paths.profileBilling}
                        render={() => <Redirect to={paths.profileBillingDocuments} />}
                    />
                    <Route
                        exact
                        path={paths.profileBillingDocuments}
                        render={() => <BillingDocuments items={props.data.documents} />}
                    />
                    <Route
                        exact
                        path={paths.profileBillingDocumentDownload(":id")}
                        component={BillingDocumentDownload}
                    />
                    <Route
                        exact
                        path={paths.profileBillingPayments}
                        render={() => <BillingPayments items={props.data.payments} />}
                    />
                    <Route
                        exact
                        path={paths.profileBillingCharges}
                        render={() => <BillingCharges items={props.data.charges} />}
                    />
                    <Route
                        exact
                        path={paths.profileBillingNotifications}
                        render={() => <BillingNotificationUsers {...props} />}
                    />
                </Switch>
            </div>
        </div>
    );
}
